module.exports = __webpack_public_path__ + "img/글레디에이터.ab126f3f.png";